import React from 'react';
import './Game.css';
import './config/configuration.js';


function Game() {
  <div id="Savages-Online"></div>
};

export default Game;